import { render, staticRenderFns } from "./SwitchTextbookDialog.vue?vue&type=template&id=b99b5d36&scoped=true"
import script from "./SwitchTextbookDialog.vue?vue&type=script&lang=js"
export * from "./SwitchTextbookDialog.vue?vue&type=script&lang=js"
import style0 from "./SwitchTextbookDialog.vue?vue&type=style&index=0&id=b99b5d36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99b5d36",
  null
  
)

export default component.exports